<script>
	import Header from './Components/Header.svelte';
	import Copy from './Components/Copy.svelte';
	import Faq from './Components/Faq.svelte';
</script>

<Header />
<section class="hero is-fullheight first-hero" />
<Copy />
<Faq />
<section class="hero is-medium footer">
	<div class="container has-text-centered">
		<p class="footercopy">INTERNATIONAL BRIGADE OF KYIV</p>
	</div>
</section>
